import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('banks', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('banks', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`banks/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`banks/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        createBranch: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('branches', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        updateBranch: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`branches/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        removeBranch: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`branches/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
